import CreateNewList from './CreateNewList';

export default CreateNewList;
